import { type FC } from 'react';
import { formatDistanceToNow } from 'date-fns';
import { isNil } from 'lodash';

import type { Application, Evaluation } from '@/types';

interface ApplicationDetailsFieldsProps {
  application?: Application;
  latestEvaluation?: Evaluation;
}

const ApplicationDetailsFields: FC<ApplicationDetailsFieldsProps> = ({
  application,
  latestEvaluation,
}) => (
  <div className="flex flex-wrap lg:grid lg:grid-cols-2 gap-x-3 gap-y-3">
    <div className="flex flex-col gap-1">
      <p className="text-xs lg:text-sm text-gray-500">BIT Id</p>
      <p className="text-sm">{application?.bitId}</p>
    </div>
    <div className="flex flex-col gap-1">
      <p className="text-xs lg:text-sm text-gray-500">Division</p>
      <p className="text-sm">{application?.division}</p>
    </div>
    <div className="flex flex-col gap-1">
      <p className="text-xs lg:text-sm text-gray-500">Total Evaluations</p>
      <p className="text-sm">
        {latestEvaluation?.totalEvaluations
          ? latestEvaluation.totalEvaluations
          : 'N/A'}
      </p>
    </div>
    <div className="flex flex-col gap-1">
      <p className="text-xs lg:text-sm text-gray-500">Last Evaluated At</p>
      <p className="text-sm">
        {!isNil(latestEvaluation?.generatedAt)
          ? formatDistanceToNow(
              new Date(latestEvaluation?.generatedAt || new Date()),
              { addSuffix: true },
            )
          : 'N/A'}
      </p>
    </div>
    <div className="flex flex-col gap-1">
      <p className="text-xs lg:text-sm text-gray-500">DB Ops</p>
      <p className="text-sm">{application?.dbOps}</p>
    </div>
    <div className="flex flex-col gap-1">
      <p className="text-xs lg:text-sm text-gray-500">Infra Ops</p>
      <p className="text-sm">{application?.infraOps}</p>
    </div>
    <div className="flex flex-col gap-1">
      <p className="text-xs lg:text-sm text-gray-500">Hosting Model</p>
      <p className="text-sm">{application?.hostingModel ?? 'N/A'}</p>
    </div>
  </div>
);

export default ApplicationDetailsFields;
